import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import theme from '@ecp/common/src/style/theme/default';
import { FlexBoxColumn, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import SearchRealTimeList from '@fo-pages/search/components/SearchRealTimeList';

const SearchRealTime = ({ referenceTime, realTimeKeywordList, handleSearch }) => {
  const mappedRealTimeKeywordList = useMemo(() => {
    return realTimeKeywordList.map((it) => ({ ...it, ranking: it?.ranking || 0 }));
  }, [realTimeKeywordList]);

  return (
    <div data-ds-label2={'g_real_time_search'}>
      <Wrapper >
        <Spacing top={20} />
        <FlexBoxSpaceBetween width={'100%'}>
          <SearchKeyword size={theme.font.size.$28} weight={theme.font.weight.bold}>
            실시간 검색어
          </SearchKeyword>
          <TextBox size={theme.font.size.$12} weight={theme.font.weight.demiLight} color={theme.color.text.guide} height={'21px'}>
            {referenceTime} 기준
          </TextBox>
        </FlexBoxSpaceBetween>
        <Spacing top={20} />
      </Wrapper>
      <Wrapper>
        <SearchRealTimeList list={mappedRealTimeKeywordList} handleSearch={handleSearch} />
      </Wrapper>
    </div>
  );
};

const Wrapper = styled(FlexBoxColumn)`
  width: 100%;
`;

const SearchKeyword = styled(TextBox)`
  font-size: ${theme.font.size.title};
  font-weight: ${theme.font.weight.bold};
  height: 22px;
`;

export default SearchRealTime;

SearchRealTime.propTypes = {
  realTimeKeywordList: PropTypes.array,
  referenceTime: PropTypes.string,
  handleSearch: PropTypes.func,
};
